module.exports = __webpack_public_path__ + "images/emoji/art.541bbdff6c850de92787.png";